/**
 * ForgotPasswordInternal screen styles
 */

import { StyleSheet } from 'react-native';

import AppStyles from '../../AppStyles';

const styles = StyleSheet.create({
  safeAreaContainer: {
    flex: 1,
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  container: {
    flex: 1,
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    color: 'black',
    fontWeight: '500',
    marginVertical: 15,
  },
  footerButtonContainer: {
    marginVertical: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },
  forgotPasswordButtonText: {
    color: AppStyles.colorSet.brandPrimary,
    fontSize: 18,
    fontWeight: '600',
  },
});

export default styles;
